;(function () {
  'use strict'

  angular
    .module('contrast.charts')
    .factory('pieChartOptionsService', pieChartOptionsServiceFactory)

  function pieChartOptionsServiceFactory(metricService) {
    'ngInject'

    var service = {
      get: get
    }

    return service

    function get() {
      return {
        series: {
          pie: {
            show: true
          }
        },
        legend: {
          show: true,
          noColumns: 1,
          container: null
        },
        grid: {
          hoverable: true,
          clickable: true
        },
        highlightColor: 'rgba(255,255,255,0.4)',
        colors: [
          '#94b758',
          '#578ebe',
          '#f3c536',
          '#fa7b58',
          '#c01920',
          '#767676'
        ],
        tooltip: true,
        tooltipOpts: {
          shifts: {
            x: -10,
            y: -70
          },
          content: function (label, xval, yval) {
            var size = metricService.getSizeShorthand(yval, 0)
            return (
              "<span class='size-h4'><strong>%s</strong><br/>" +
              size +
              ' vuln(s)</span>'
            )
          },
          defaultTheme: false
        }
      }
    }
  }
})()
